import { render, staticRenderFns } from "./iframe-page-view.vue?vue&type=template&id=01411147&scoped=true"
import script from "./iframe-page-view.vue?vue&type=script&lang=js"
export * from "./iframe-page-view.vue?vue&type=script&lang=js"
import style0 from "./iframe-page-view.vue?vue&type=style&index=0&id=01411147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01411147",
  null
  
)

export default component.exports